import { baseUrl, httpClient } from '../../providers/AppDataProvider';
import { DisplayText } from './types';

export async function apiGet<T>(path: string): Promise<T> {
  const { json } = await httpClient(`${baseUrl}${path}`, { method: 'GET' });
  return json as T;
}

export async function apiSend<T>(path: string, method: 'PUT' | 'POST' | 'DELETE', body?: unknown): Promise<T> {
  const { json } = await httpClient(`${baseUrl}${path}`, {
    method,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });
  return json as T;
}

// Admin tables show the en override when present, else the slug, else the fallback.
export function displayLabel(t: DisplayText | null | undefined, fallback: string): string {
  return t?.en || t?.slug || fallback;
}
